export default "__VITE_ASSET__B$xK9l0E__"